package br.com.texeratx.boardgametimeapp.data.model.player

import br.com.texeratx.boardgametimeapp.data.model.match.MatchListItemDTO
import kotlinx.serialization.Serializable

@Serializable
data class PlayerOwnedGameDTO(
    val id: Long,
    val name: String,
    val imageUrl: String?
)

@Serializable
data class PlayerWinsByGameDTO(
    val gameId: Long,
    val gameName: String,
    val gameImageUrl: String?,
    val wins: Int
)

@Serializable
data class PlayerDetailStatsDTO(
    val wins: Int,
    val participations: Int,
    val minutesPlayed: Int,
    val winsCurrentYear: Int,
    val participationsCurrentYear: Int,
    val minutesPlayedCurrentYear: Int
)

@Serializable
data class PlayerDetailDTO(
    val id: Long,
    val name: String,
    val nickname: String?,
    val imageUrl: String?,
    val birthday: String?,
    val phone: String?,
    val status: Int,
    val clanId: Long,
    val gamesOwned: List<PlayerOwnedGameDTO> = emptyList(),
    val recentMatches: List<MatchListItemDTO> = emptyList(),
    val winsByGame: List<PlayerWinsByGameDTO> = emptyList(),
    val matchupStats: PlayerMatchupStatsDTO? = null,
    val stats: PlayerDetailStatsDTO = PlayerDetailStatsDTO(
        wins = 0,
        participations = 0,
        minutesPlayed = 0,
        winsCurrentYear = 0,
        participationsCurrentYear = 0,
        minutesPlayedCurrentYear = 0
    )
)

@Serializable
data class PlayerMatchupStatsDTO(
    val total: MatchupPeriodDTO = MatchupPeriodDTO(),
    val currentYear: MatchupPeriodDTO = MatchupPeriodDTO()
)

@Serializable
data class MatchupPeriodDTO(
    val highlights: MatchupHighlightsDTO = MatchupHighlightsDTO(),
    val topRivals: List<RivalMatchupDTO> = emptyList()
)

@Serializable
data class MatchupHighlightsDTO(
    val mostDefeated: RivalMatchupDTO? = null,
    val mostLostTo: RivalMatchupDTO? = null,
    val mostPlayedTogether: RivalMatchupDTO? = null
)

@Serializable
data class RivalMatchupDTO(
    val opponentId: Long,
    val opponentName: String,
    val opponentNickname: String? = null,
    val opponentImageUrl: String? = null,
    val matchesTogether: Int = 0,
    val wins: Int = 0,
    val losses: Int = 0,
    val winRatePct: Int = 0,
    val dominance: Int = 0,
    val lastMatchDate: String? = null,
    val bestGameAgainst: MatchupGameSummaryDTO? = null,
    val worstGameAgainst: MatchupGameSummaryDTO? = null
)

@Serializable
data class MatchupGameSummaryDTO(
    val gameId: Long,
    val gameName: String,
    val gameImageUrl: String? = null,
    val wins: Int = 0,
    val losses: Int = 0
)
